import React from "react";

const INFORMATIVE_ACMG_MESSAGE = __IS_COMPONENTS_PORTAL__ ? (
  ""
) : (
  <span>{" - Educational use only"}</span>
);

const FAMILY_MEMBERS_AFFECTED_MAP = {
  True: "Yes",
  False: "No",
  Unknown: "Unknown",
};

export { INFORMATIVE_ACMG_MESSAGE, FAMILY_MEMBERS_AFFECTED_MAP };
